import React from "react";
import Image from "next/image";

type Props = {
    isDateStructureConsistent?: boolean;
};

export const DateStructureConsistent: React.FC<Props> = ({ isDateStructureConsistent }) => {
    // If prop is omitted, default to false (show the not-consistent UI).
    const consistent = Boolean(isDateStructureConsistent);

    return consistent ? (
        <div className="relative mt-4 md:mt-3 flex w-full items-center justify-center rounded-xl bg-[#FCFCFC] p-6 text-center font-montserrat shadow-sm lg:px-8">
            {/* Badge / Icon Title in the top-left (half-out style) */}
            <div className="absolute left-4 -top-6 flex items-center gap-3 rounded-xl bg-white px-4 py-2 text-base font-semibold shadow-md">
                <Image
                    src="/icons/score-check/date.svg"
                    width={28}
                    height={28}
                    alt="date icon"
                    className="h-6 w-6"
                />
                <span className="text-base">Date Structure</span>
            </div>

            <div className="mx-auto flex max-w-4xl flex-col items-center justify-center gap-6 px-4 py-6">
                <h3 className="text-sm font-semibold text-[#32B344] lg:text-xl">
                    Consistent Date Structure was found
                </h3>

                <div className="flex items-center justify-center">
                    <Image
                        src="/assets/resumeScore/date.png"
                        alt="illustration"
                        width={260}
                        height={160}
                        className="object-contain"
                    />
                </div>

                <p className="max-w-3xl text-center text-xs lg:text-base text-gray-700">
                    Consistent date formats make your resume clear, professional, and easy to follow.
                </p>
            </div>
        </div>
    ) : (
        <div className="relative mt-4 md:mt-3 flex w-full items-center justify-center rounded-xl bg-[#FCFCFC] p-6 text-center font-montserrat shadow-sm lg:px-8">
            <div className="absolute left-4 -top-6 flex items-center gap-3 rounded-xl bg-white px-4 py-2 text-base font-semibold shadow-md">
                <Image
                    src="/icons/score-check/date.svg"
                    width={28}
                    height={28}
                    alt="date icon"
                    className="h-6 w-6"
                />
                <span className="text-base">Date Structure</span>
            </div>

            <div className="mx-auto flex max-w-4xl flex-col items-center justify-center gap-6 px-4 py-6">
                <h3 className="text-sm font-semibold text-red-600 lg:text-xl">
                    Date structure not consistent
                </h3>

                <div className="flex items-center justify-center">
                    <Image
                        src="/assets/resumeScore/date.png"
                        alt="illustration"
                        width={260}
                        height={160}
                        className="object-contain"
                    />
                </div>

                <p className="max-w-3xl text-center text-xs lg:text-base text-gray-700">
                    We found date entries that don't follow the same format — consider using a single, consistent style (e.g. "Jan 2020 - Dec 2021") across your experience entries.
                </p>
            </div>
        </div>
    );
};